import { IProps } from './AlertTypeWaterLevel'
import SubscriptionItem from './SubscriptionItem'
import {
  NotificationTypeManualSitesMap,
  NotificationTypeMap,
} from '../../helper/constants'
import { MeasurementType } from '../../helper/enum'

const AlertTypeDefault: React.FC<IProps> = ({
  data,
  isActiveSubscription,
  updateState,
}) => {
    const { measurementType, name, isAutomated, description } = data

    const descriptionText = () => {
        if (!isAutomated) return 'Community Notification';
        switch (measurementType) {
            case MeasurementType.Irrigation:
                return "This notification has been created for a specific purpose. New subscribers should contact engagement@hydro.com.au to understand how best to interpret this data.";
            default:
                return measurementType;
        }
    }
                

  return (
    <div className="marker-info-wrapper">
      <div className="text-wa">{name}</div>
      <div className="mt-2 leading-5 text-sm max-w-lg">
        {descriptionText()}
      </div>
      <div className="mt-2 leading-5 max-w-md text-center">
        {isAutomated ? '' : description}
      </div>
      <div
        className={`notif-type-wrapper mt-6  ${
          data.isAutomated ? 'justify-between' : 'justify-evenly'
        }`}
      >
        {Array.from(
          data.isAutomated
            ? NotificationTypeMap.entries()
            : NotificationTypeManualSitesMap.entries()
        ).map(([key, value]) => {
          return (
            <SubscriptionItem
              key={key}
              name={value}
              isActive={isActiveSubscription(key)}
              onClick={() => updateState(key)}
              className="w-18"
            />
          )
        })}
      </div>
    </div>
  )
}

export default AlertTypeDefault
